// @ts-nocheck
import React from 'react';

import { Container, Row, Col } from 'crehana-ui/GridV2';
import LazyImageResponsive from 'crehana-ui/LazyImage/LazyImageResponsive';
import Text from 'crehana-ui/Text';
import PrimaryButton from 'crehana-ui/Buttons/PrimaryButton';
import { useTranslation } from '@crehana/i18n';

import getStaticUrl from 'Jsx/Utils/getStaticUrl';

const LiveBanner: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Container
      className="relative h-280 bg-base-dark sm:bg-transparent"
      css={`
        ${({ theme }) => theme.breakpoints.up('sm')} {
          height: 320px;
        }
      `}
    >
      <div
        className="relative z-0 hidden h-full sm:block bg-secondary-main"
        css={`
          width: calc(100% - 16px);
        `}
      >
        <LazyImageResponsive
          alt="Crehana Live!"
          className="absolute z-0 w-full h-full mr-16"
          sources={{
            default: getStaticUrl('img/crehana-lives/banner-320.png'),
            sm: getStaticUrl('img/crehana-lives/banner-1024.png'),
            md: getStaticUrl('img/crehana-lives/banner-1440.png'),
            lg: getStaticUrl('img/crehana-lives/banner-1920.png'),
          }}
          imgClassName="object-cover object-center h-auto md:h-full z-0"
          css={`
            top: 16px;
            left: 16px;
          `}
        />
      </div>
      <Row className="absolute inset-0 z-dialog">
        <Col xs={10} sm={4} offset={1}>
          <div className="pb-64 text-center sm:pt-96 pt-80 sm:text-left">
            <Text as="h4" type="h4" color="white" className="mb-24">
              {t('LIVE_BANNER_TITLE')}
            </Text>
            <PrimaryButton
              darkMode
              label={t('LIVE_BANNER_CTA')}
              href="/live/"
            />
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default LiveBanner;
